import { useTheme } from 'styled-components';

import { CustomSvg, SvgIconDefaultProps } from '@libs/components';

const LoyalGe: React.FC<SvgIconDefaultProps> = ({
  className,
  testId,
  color,
  width,
  height,
}) => {
  const { colors } = useTheme();
  const iconColor = color ? color : colors.text.secondary;

  return (
    <CustomSvg
      className={className}
      data-cy={testId}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_45084_25373)">
        <path
          d="M22.944 12.48L21.792 10.704L22.464 8.68799C22.656 8.15999 22.416 7.63199 21.936 7.34399L20.112 6.23999L19.776 4.12799C19.68 3.59999 19.248 3.21599 18.72 3.16799L16.608 3.07199L15.312 1.43999C14.976 1.00799 14.4 0.863989 13.92 1.10399L12 2.01599L10.08 1.10399C9.59998 0.863989 9.02398 1.00799 8.68798 1.43999L7.43998 3.11999L5.27998 3.21599C4.75198 3.21599 4.27198 3.64799 4.22398 4.17599L3.88798 6.23999L2.06398 7.29599C1.58398 7.58399 1.39198 8.11199 1.53598 8.63999L2.20798 10.656L1.10398 12.48C0.815979 12.912 0.911979 13.536 1.29598 13.92L2.78398 15.36L2.59198 17.472C2.54398 18 2.87998 18.528 3.40798 18.672L5.42398 19.248L6.23998 21.216C6.43198 21.696 7.00798 21.984 7.53598 21.888L9.59998 21.456L11.232 22.8C11.424 22.944 11.712 23.04 11.952 23.04C12.192 23.04 12.48 22.944 12.672 22.8L14.304 21.456L16.368 21.888C16.896 21.984 17.424 21.696 17.664 21.216L18.48 19.248L20.496 18.672C21.024 18.528 21.36 18.048 21.312 17.472L21.216 15.36L22.752 13.872C23.136 13.488 23.232 12.912 22.944 12.48ZM7.77598 10.848C7.67998 10.56 7.67998 10.416 7.67998 9.35999C7.67998 8.30399 7.72798 8.11199 7.77598 7.87199C8.01598 7.19999 8.59198 6.71999 9.35998 6.71999C10.128 6.71999 10.704 7.15199 10.944 7.87199C11.04 8.15999 11.04 8.30399 11.04 9.35999C11.04 10.416 10.992 10.608 10.944 10.848C10.704 11.52 10.128 12 9.35998 12C8.59198 12 8.01598 11.568 7.77598 10.848ZM9.64798 17.136C9.59998 17.232 9.55198 17.28 9.45598 17.28H8.78398C8.68798 17.28 8.63998 17.184 8.68798 17.136L14.4 6.86399C14.448 6.76799 14.496 6.71999 14.64 6.71999H15.312C15.408 6.71999 15.408 6.81599 15.408 6.86399L9.64798 17.136ZM16.224 16.128C15.984 16.8 15.408 17.28 14.64 17.28C13.872 17.28 13.296 16.848 13.056 16.128C12.96 15.84 12.96 15.696 12.96 14.64C12.96 13.584 13.008 13.392 13.056 13.152C13.296 12.48 13.872 12 14.64 12C15.408 12 15.984 12.432 16.224 13.152C16.32 13.44 16.32 13.584 16.32 14.64C16.32 15.696 16.272 15.888 16.224 16.128Z"
          fill="#286AF6"
        />
        <path
          d="M14.6399 12.961C14.3039 12.961 14.0639 13.153 13.9679 13.441C13.9199 13.585 13.9199 13.729 13.9199 14.641C13.9199 15.553 13.9679 15.649 13.9679 15.793C14.0639 16.129 14.3039 16.273 14.6399 16.273C14.9759 16.273 15.2159 16.081 15.3119 15.793C15.3599 15.649 15.3599 15.505 15.3599 14.641C15.3599 13.729 15.3119 13.585 15.3119 13.441C15.2159 13.153 14.9759 12.961 14.6399 12.961Z"
          fill="#286AF6"
        />
        <path
          d="M10.0316 10.5587C10.0796 10.4147 10.0796 10.2707 10.0796 9.40665C10.0796 8.49465 10.0316 8.35065 10.0316 8.20665C9.93565 7.87065 9.69565 7.72665 9.35965 7.72665C9.02365 7.72665 8.78365 7.91865 8.68765 8.20665C8.63965 8.35065 8.63965 8.49465 8.63965 9.40665C8.63965 10.3187 8.68765 10.4147 8.68765 10.5587C8.78365 10.8947 9.02365 11.0387 9.35965 11.0387C9.69565 11.0387 9.93565 10.8467 10.0316 10.5587Z"
          fill="#286AF6"
        />
      </g>
      <defs>
        <clipPath id="clip0_45084_25373">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </CustomSvg>
  );
};

export default LoyalGe;
